module.exports = __webpack_public_path__ + "static/media/4ODA17.9f427562.jpg";